module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-23-min.564b4e7a.jpg";